import { withStyles } from "@material-ui/core";
import React from "react";
import Details from "./Details";
import DetailsList from "./DetailsList";

const styles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 12 0 12",
    flexWrap: "wrap"
  },
  detail: {
    display: "flex",
    alignItems: "center",
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
    margin: "15px 0px 15px",
  },
  header: {
    fontWeight: "600",
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    padding: "2px 0px",
    color: theme.HeaderSelectedText,
  },
  item: {
    display: "flex",
  },
});
const StopDetails = ({ classes, stopData, pickupData, deliveryData }) => {
  return (
    <div className={classes.container}>
      <div>
        <div className={classes.header}>Stops</div>
        <div className={classes.item}>
          <DetailsList
            labels={["To Do", "Done"]}
            values={[stopData.toDo, stopData.done]}
          />
        </div>
      </div>
      <div>
        <div className={classes.header}>Pickups</div>
        <div className={classes.item}>
          <DetailsList
            labels={["To Do", "Done"]}
            values={[pickupData.toDo, pickupData.done]}
          />
          <Details label="Pieces" value={pickupData.pieces} />
          <Details label="Weight" value={pickupData.weight} />
        </div>
      </div>
      <div>
        <div className={classes.header}>Deliveries</div>
        <div className={classes.item}>
          <DetailsList
            labels={["To Do", "Done"]}
            values={[deliveryData.toDo, deliveryData.done]}
          />
          <Details label="Pieces" value={deliveryData.pieces} />
          <Details label="Weight" value={deliveryData.weight} />
          <Details label="Returned" value={deliveryData.returned} />
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(StopDetails);
